{
  "title": "Summon Aberration",
  "source": "Tasha's Cauldron of Everything",
  "levelAndSchool": "4th-level conjuration",
  "level": 4,
  "castingTime": "1 action",
  "range": "90 feet",
  "components": "V, S, M (a pickled tentacle and an eyeball in a platinum inlaid vial worth at least 400 gp)",
  "duration": "Concentration, up to 1 hour",
  "description": [
    "You call forth an aberrant spirit. It manifests in an unoccupied space that you can see within range. This corporeal form uses the Aberrant Spirit stat block. When you cast the spell, choose Beholderkin, Slaad, or Star Spawn. The creature resembles an aberration of that kind, which determines certain traits in its stat block. The creature disappears when it drops to 0 hit points or when the spell ends.",
    "The creature is an ally to you and your companions. In combat, the creature shares your initiative count, but it takes its turn immediately after yours. It obeys your verbal commands (no action required by you). If you don’t issue any, it take the Dodge action and uses its move to avoid danger.",
    "At Higher Levels. When you cast this spell using a spell slot of 5th level or higher, use the higher level wherever the spell's level appears on the stat block.",
    "Aberrant Spirit",
    "Medium aberration",
    "Armor Class: 11 + the level of the spell (natural armor)",
    "Hit Points: 40 + 10 for each spell level above 4th",
    "Speed: 30 ft., fly 30 ft. (hover) (Beholderkin only)",
    "STR",
    "DEX",
    "CON",
    "INT",
    "WIS",
    "CHA",
    "16 (+3)",
    "10 (+0)",
    "15 (+2)",
    "16 (+3)",
    "10 (+0)",
    "6 (−2)",
    "Damage Immunities: psychic",
    "Senses: darkvision 60 ft., passive Perception 10",
    "Languages: Deep Speech, understands the languages you speak",
    "Challenge: —",
    "Proficiency Bonus: equals your bonus",
    "Regeneration (Slaad Only). The aberration regains 5 hit points at the start of its turn if it has at least 1 hit point.",
    "Whispering Aura (Star Spawn Only). At the start of each of the aberration’s turns, each creature within 5 feet of the aberration must succeed on a Wisdom saving throw against your spell save DC or take 2d6 psychic damage, provided that the aberration isn’t incapacitated.",
    "Actions",
    "Multiattack. The aberration makes a number of attacks equal to half this spell’s level (rounded down).",
    "Claws (Slaad Only). Melee Weapon Attack: your spell attack modifier to hit, reach 5 ft., one target. Hit: 1d10 + 3 + the spell’s level slashing damage. If the target is a creature, it can’t regain hit points until the start of the aberration’s next turn.",
    "Eye Ray (Beholderkin Only). Ranged Spell Attack: your spell attack modifier to hit, range 150 ft., one creature. Hit: 1d8 + 3 + the spell’s level psychic damage.",
    "Psychic Slam (Star Spawn Only). Melee Spell Attack: your spell attack modifier to hit, reach 5 ft., one creature. Hit: 1d8 + 3 + the spell’s level psychic damage"
  ],
  "spellLists": ["warlock", "wizard"]
}
